import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Partners } from './components/Partners';
import { TrustBar } from './components/TrustBar';
import { AboutCoach } from './components/AboutCoach';
import { Tier1Specialized } from './components/Tier1Specialized';
import { Tier2Institutional } from './components/Tier2Institutional';
import { Tier3Memberships } from './components/Tier3Memberships';
import { Gallery } from './components/Gallery';
import { Faq } from './components/Faq';
import { RegistrationForm } from './components/RegistrationForm';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyContactBar } from './components/StickyContactBar';
export function App() {
  return <div className="w-full min-h-full bg-ink text-white" data-id="element-0" data-mp="28te1n9vnj3li">
      <Navbar data-id="element-1" data-mp="23vck4tdvjcc5" />
      <main data-id="element-2" data-mp="23vuo6c6s2uum">
        <Hero data-id="element-3" data-mp="23w4drynwuzzs" />
        <TrustBar data-id="element-4" data-mp="23ujk0b9f7l2z" />
        <AboutCoach data-id="element-5" data-mp="23v2rsz5cwt3a" />
        <Tier1Specialized data-id="element-6" data-mp="23ti6m04xmmi3" />
        <Tier2Institutional data-id="element-7" data-mp="3ikhaeg9qb525" />
        <Tier3Memberships data-id="element-8" data-mp="3ij65ue8glt9z" />
        <Gallery data-id="element-9" data-mp="3ihv0i9zd8dgr" />
        <Partners data-id="element-10" data-mp="3mlj82snzz920" />
        <Faq data-id="element-11" data-mp="3ml12h5fg3ihf" />
        <RegistrationForm data-id="element-12" data-mp="3mkhmhu9cv461" />
      </main>
      <Footer data-id="element-13" data-mp="3mjga9mglsbmq" />
      <SocialProofPopup data-id="element-14" data-mp="3rc9em985thya" />
      <StickyContactBar data-id="element-15" data-mp="3rbrc4uuwm7hx" />
    </div>;
}